import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { EASE } from "./primitives";
import logo from "../../assets/logo.png";

export const NotFound = () => (
  <div
    data-testid="not-found-page"
    className="relative min-h-screen w-full overflow-hidden bg-[#07040D] flex flex-col items-center justify-center px-6 text-center"
  >
    <div className="grain-overlay" />
    <div className="aura w-[600px] h-[600px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />

    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: EASE }}
      className="relative z-10 flex flex-col items-center"
    >
      <img
        src={logo}
        alt="Tarot Guidance by Ishita Dhar"
        width="554"
        height="160"
        decoding="async"
        className="h-12 sm:h-14 w-auto object-contain opacity-90 mb-10"
      />

      <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
        Page Not Found
      </span>

      <h1 className="mt-6 font-serif-display font-light text-[#EAE0D5] text-6xl sm:text-8xl leading-[0.95] tracking-tight">
        4<span className="italic text-[#D4AF37]">0</span>4
      </h1>

      <p className="mt-6 max-w-md text-[#A89FA8] text-base sm:text-lg leading-relaxed">
        The path you seek has faded into the mist. Let the cards guide you back.
      </p>

      <a
        href="/"
        data-testid="not-found-home-btn"
        className="mt-12 group inline-flex items-center gap-3 rounded-full bg-[#D4AF37] text-[#07040D] px-8 py-4 text-xs tracking-[0.2em] uppercase hover:bg-[#F2D06B] transition-colors duration-300"
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={1.8} />
        Return Home
      </a>
    </motion.div>
  </div>
);
